import React from 'react';

export const CreateInputPage: React.FC = React.memo(() => {
  return null;
});
